var $784ec4e789b99a71$exports = {};
$784ec4e789b99a71$exports = {
  "help": `\u{B3C4}\u{C6C0}\u{B9D0}`,
  "info": `\u{C815}\u{BCF4}`
};
export { $784ec4e789b99a71$exports as default };